<template>
  <div>
    <!-- HEADER WITH MAINNAV: CONTACT-, WEBSITE- AND SERVICE-NAVIGATION -->

    <header>
      <div>
        <MenuMain />
      </div>
    </header>

    <ContainerFlex>
      <template slot="aside-left">
        <AsideLeft>
          <template slot="title"> Dienstleistungen </template>
          <li
            v-for="service in services"
            :key="service.id"
            class="category-left transition"
          >
            <nuxt-link :to="service.url" class="cursor-pointer">
              {{ service.title }}
            </nuxt-link>
          </li>
        </AsideLeft>
      </template>

      <!-- CENTER - BLOGPOSTS -->

      <template slot="main-content">
        <div class="mt-4 lg:mt-0 mx-4 lg:mx-0">
          <div class="w-full bg-grey-lighter mb-4 p-6 text-white">
            <Paragraph>
              <h4>
                {{ title }}
              </h4>
              <h3 class="text-blue-darker">
                {{ subtitle }}
              </h3>
              <!-- eslint-disable-next-line -->
              <div class="text-blue-dark" v-html="content" />
            </Paragraph>
          </div>
          <div>
            <ContentCard
              v-for="entry in entries"
              :key="entry.id"
              is-blog-post
              :href="entry.url"
              :sale="entry.sale"
              :bestseller="entry.bestseller"
              :news="entry.news"
              class="wow fadeIn my-4"
              data-wow-duration="0.5s"
            >
              <template slot="img">
                <img
                  class="special-img-lg"
                  :src="entry.image"
                  alt="post image"
                />
              </template>
              <template slot="name">
                {{ entry.date }} - {{ entry.title }}
              </template>
              <!-- eslint-disable-next-line vue/no-v-html -->
              <div
                v-if="entry.summary"
                class="text-sm leading-custom mt-4"
                v-html="entry.summary"
              />
            </ContentCard>

            <button
              v-if="hasMore"
              class="rounded-smg bg-grey-light text-center text-red font-semibold text-sm uppercase py-4 w-full mt-12 mb-3 hover:bg-grey-darker hover:text-white transition"
              :disabled="loading"
              @click="loadMore"
            >
              Mehr anzeigen
            </button>
          </div>
        </div>
      </template>

      <!-- ASIDE RIGHT -->

      <template slot="aside-right">
        <AsideRight :coworker="consulter" />
      </template>
    </ContainerFlex>

    <!-- MENU SERVICE -->
    <div class="bg-grey-light">
      <Container class="py-13">
        <MenuService class="-mx-2 wow fadeIn" />
      </Container>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import MenuMain from '~/components/menu/MenuMain'
import MenuService from '~/components/menu/MenuService'
import Container from '~/components/layoutelements/Container'

import ContainerFlex from '~/components/layoutelements/ContainerFlex'
import AsideLeft from '~/components/layoutelements/AsideLeft'
import AsideRight from '~/components/layoutelements/AsideRight'
import Paragraph from '~/components/Paragraph'
import ContentCard from '~/components/cardtypes/ContentCard'

export default {
  components: {
    MenuMain,
    MenuService,
    Container,
    ContainerFlex,
    AsideLeft,
    AsideRight,
    Paragraph,
    ContentCard,
  },

  async asyncData({ route, $axios }) {
    const result = await $axios.$get('/blog/?limit=5')
    return result
  },

  data() {
    return {
      limit: 4,
      start: 5,
      loading: false,
      hasMoreFlag: true,
    }
  },

  computed: {
    ...mapState('settings', ['services']),

    hasMore() {
      return this.hasMoreFlag && this.entries.length >= this.limit
    },
  },

  methods: {
    loadMore() {
      this.loading = true
      this.$axios
        .$get('/blog/?limit=' + this.limit + '&start=' + this.start)
        .then((response) => {
          if (response.entries.length < this.limit) {
            this.hasMoreFlag = false
          }
          this.entries.push(...response.entries)
          this.start += this.limit
          this.loading = false
        })
    },
  },
}
</script>
